import client from '../../client'
import {
  CreditCardId,
  ApiCreditCard,
  CreditCardCreateResponse,
  CreditCardToken,
  CreditCard,
  ChargeType,
  ChargeCreditResponse,
  PaymentId,
  PurchaseHistoryResponse,
  IssueReceiptParams,
} from './types'
import { ApiResponse } from '../../types'

export * from './types'

const convertCreditCard = ({ cardId, ...rest }: ApiCreditCard): CreditCard => ({
  ...rest,
  id: cardId,
})

export const createCreditCard = (
  token: CreditCardToken
): Promise<CreditCardCreateResponse> =>
  client.post('/user/payments/credit/card', {
    'payjp-token': token,
  })

export const destroyCreditCard = (cardId: CreditCardId) =>
  client.delete(`/user/payments/credit/card/${cardId}`)

export const listCreditCard = async () => {
  const { data }: ApiResponse<ApiCreditCard[]> = await client.get(
    '/user/payments/credit/card'
  )
  return data.map(convertCreditCard)
}

export const changeDefaultCreditCard = (cardId: CreditCardId) =>
  client.put(`/user/payments/credit/card/default`, { cardId })

export const chargeCredit = async (
  cardId: CreditCardId,
  price: number,
  chargeType: ChargeType = ChargeType.BULK
) => {
  const { data }: ApiResponse<ChargeCreditResponse> = await client.post(
    `/user/payments/credit/charge`,
    { cardId, price },
    { params: { type: chargeType } }
  )
  return data
}

export const refund = async (paymentId: PaymentId) =>
  await client.delete(`/user/payments/refund/${paymentId}`)

export const listPurchaseLog = async () => {
  const { data }: ApiResponse<PurchaseHistoryResponse> = await client.get(
    `/user/payments/purchase/log`
  )
  return data
}

export const issueReceipt = async (
  paymentId: PaymentId,
  params: IssueReceiptParams
) => {
  await client.post(`/user/payments/receipt/${paymentId}`, params)
}
